/* TRU KAVA tk27 · shared product-page purchase core: real /cart/add.js requests */
(function(){
  'use strict';
  var T = window.TK27 = window.TK27 || {};
  function root(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  T.add = function(items){
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : root() + 'cart/add') + '.js';
    return fetch(url, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify({items: items})})
      .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(j){ if(!r.ok){ j.status = r.status; throw j; } return j; }); })
      .then(function(added){
        return fetch(root() + 'cart.js', {credentials: 'same-origin', headers: {'Accept': 'application/json'}}).then(function(r){ return r.json(); }).catch(function(){ return null; })
          .then(function(cart){ document.dispatchEvent(new CustomEvent('tk27:cart-added', {detail: {items: added, cart: cart}})); return added; });
      });
  };
  /* ?tk=sub-3 / ?tk=once-1 preselects a purchase state (used by the homepage Ritual CTA) */
  T.param = function(){ var m = /[?&]tk=(once|sub)-(\d+)/.exec(window.location.search); return m ? {plan: m[1], qty: +m[2]} : null; };
})();
